/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegionInputModel } from '../../models/region-input-model';
import { RegionModel } from '../../models/region-model';

export interface PostApiRegionV1Regions$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * Region model
     */
    body?: RegionInputModel
}

export function postApiRegionV1Regions$Json(http: HttpClient, rootUrl: string, params?: PostApiRegionV1Regions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionModel>> {
  const rb = new RequestBuilder(rootUrl, postApiRegionV1Regions$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegionModel>;
    })
  );
}

postApiRegionV1Regions$Json.PATH = '/private/v1/regions/create';
